module.exports = __webpack_public_path__ + "static/media/avatar.c7aadebe.jpg";